import React from 'react';
import {
    Switch, Route, useLocation
    //, BrowserRouter
    //, Redirect
} from 'react-router-dom';
import {
    //HesapOlusturSayfa,
    KullaniciBilgiSayfa, OturumAcSayfa, SifreDegistirSayfa, SifreSifirlaSayfa} from './pages';
// import { LoginForm } from './components';
import {useAppState} from "./contexts/app-state";

const NoMatch = () => {
    let location = useLocation();
    //console.log('no match '+location.pathname);
    window.location = location.pathname;
    return false;
}

const getComponentByName = (name) => {
    let component;
    switch (name) {
        case 'OturumAcSayfa':
            component = OturumAcSayfa;
            break;
        case 'SifreSifirlaSayfa':
            component = SifreSifirlaSayfa ;
            break;
        case 'SifreDegistirSayfa':
            component = SifreDegistirSayfa ;
            break;
        case 'KullaniciBilgiSayfa':
            component = KullaniciBilgiSayfa ;
            break;
        // case 'HesapOlusturSayfa':
        //     component = HesapOlusturSayfa ;
        //     break;
        default:
            component = NoMatch;
            break;
    }
    return component;
}

export default function () {
  const {state} = useAppState();
  return (
    <Switch>
        <Route exact path='/' component={getComponentByName(state.pages[0].component)} />
        {
            state.pages.map(
                ({ path, component }) => <Route exact key={path} path={path} component={getComponentByName(component)}/>
            )
        }
      {/*<Redirect to={'/login'} />*/}
      {/*  <Route component={Hata404Sayfa} />*/}
        <Route>
            <NoMatch />
        </Route>
    </Switch>

  );
}
